import { render, staticRenderFns } from "./Hjem.vue?vue&type=template&id=45e4a45d&"
import script from "./Hjem.vue?vue&type=script&lang=js&"
export * from "./Hjem.vue?vue&type=script&lang=js&"
import style0 from "./Hjem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports